"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ExpandButtonWrapper = exports.ExpandButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _button = _interopRequireDefault(require("@paprika/button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ExpandButton = (0, _styledComponents["default"])(_button["default"].Icon).withConfig({
  displayName: "ExpandButtonstyles__ExpandButton",
  componentId: "sc-1fk5swf-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["color:", ";height:20px;margin:-3px ", " 0;min-height:20px;width:20px;&:hover{background-color:", ";}"], isDark ? _tokens["default"].color.white : _tokens["default"].textColor.subtle, _tokens["default"].spaceSm, isDark ? _tokens["default"].color.blackLighten10 : _tokens["default"].color.blackLighten70);
});
exports.ExpandButton = ExpandButton;

var ExpandButtonWrapper = _styledComponents["default"].li.withConfig({
  displayName: "ExpandButtonstyles__ExpandButtonWrapper",
  componentId: "sc-1fk5swf-1"
})(function (_ref2) {
  var isHidden = _ref2.isHidden;
  return (0, _styledComponents.css)(["display:", ";list-style-type:none;margin:0;padding:0;&::before{content:\"/\";}"], isHidden ? "none" : "inline");
});

exports.ExpandButtonWrapper = ExpandButtonWrapper;
//# sourceMappingURL=ExpandButton.styles.js.map